import React, { useEffect } from "react";

/** KioskLayout — full-screen, no admin chrome, branding-aware.
 * Critical: clears the admin JWT on mount so kiosk + admin tokens cannot co-mingle.
 */
export default function KioskLayout({ children, branding }) {
  useEffect(() => {
    // Strip admin JWT from local storage so kiosk pages can't accidentally call admin APIs
    // with an admin token.
    localStorage.removeItem("eb_access_token");
    localStorage.removeItem("eb_refresh_token");
    document.body.classList.add("kiosk-mode");
    return () => document.body.classList.remove("kiosk-mode");
  }, []);

  const primary = branding?.primary_color || "#1B2A4A";
  const accent = branding?.accent_color || "#FF6B35";
  const bg = branding?.background_url
    ? `url(${branding.background_url}) center/cover no-repeat`
    : `linear-gradient(135deg, ${primary} 0%, #0F1A2E 100%)`;

  return (
    <div
      className="min-h-screen w-full text-white relative overflow-hidden grain"
      style={{
        background: bg,
        ["--kiosk-primary"]: primary,
        ["--kiosk-accent"]: accent,
      }}
      data-testid="kiosk-layout"
    >
      {/* subtle accent radial */}
      <div
        className="absolute inset-0 pointer-events-none opacity-30"
        style={{
          backgroundImage: `radial-gradient(circle at 20% 20%, ${accent}55, transparent 40%), radial-gradient(circle at 80% 90%, ${accent}33, transparent 50%)`,
        }}
      />
      <div className="relative z-10 w-full max-w-[1200px] mx-auto px-6 md:px-12 py-8 md:py-12 min-h-screen flex flex-col">
        {children}
      </div>
    </div>
  );
}
